import { Box, Card, styled } from '@mui/material';

const StyledRoot = styled(Box)(({ theme }) => ({
  padding: '1rem',
  marginBottom: theme.spacing(2),
}));

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#f9fdfe',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(2),
  marginTop: theme.spacing(1),
  boxShadow: theme.shadows[1],
}));

const StyledTypography = styled('h3')({});

const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export { StyledRoot, StyledCard, StyledTypography, TitleWrapper, Wrapper };
